import { chain, sumBy } from 'lodash';
import React from 'react';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import { formatPercent } from '../../../../../logic/otherUtilities/formatting/formatPercent';
import VoxelLoadingSpinner from '../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';

export interface TableCellTrendProps {
  keyword: ProjectKeywordGq;
  longMonthDisabled: boolean;
}

const TableCellTrend: React.FC<TableCellTrendProps> = React.memo(
  ({ keyword, longMonthDisabled }) => {
    const monthValues12 = chain(keyword.months2)
      .slice(36 - 12)
      .value();

    const monthValues24 = chain(keyword.months2)
      .slice(36 - 24)
      .value();

    const sumCurrent = sumBy(monthValues12, (v) => v);
    const sumPrevious = sumBy(monthValues24, (v) => v) - sumCurrent;
    const trend = (sumCurrent - sumPrevious) / (sumPrevious ?? 1);
    const trendPositive = trend > 0;
    const trendNegative = trend < 0;
    const trendAvailable =
      sumPrevious > 0 && monthValues12.length === 12 && monthValues24.length == 24;

    return (
      <VoxelDataTableCell align="right">
        {keyword.fetchingNewVolume && (
          <div className="flex flex-row justify-end items-center gap-2 flex-nowrap">
            <VoxelLoadingSpinner />
          </div>
        )}
        {!longMonthDisabled && trendAvailable && (
          <div className="flex flex-row justify-end items-center flex-nowrap">
            <span
              className={`
              !text-xs
                ${trendPositive && 'text-success-600'}
                ${trendNegative && 'text-error-500'}
              `}
            >
              {trendPositive ? '+' : ''}
              {formatPercent(keyword.trend ?? trend)}%
            </span>
          </div>
        )}
      </VoxelDataTableCell>
    );
  }
);

export default TableCellTrend;
